// src/App.tsx

import React, { useEffect } from "react";
import { useRoutes } from "react-router-dom";
import routes from "@/router";
import { UserProvider } from "@/context/UserContext";
import ScrollToTop from "@/modules/common/ScrollToTop"; 
import { ServiceProvider } from "./modules/service_request_manage/context/ServiceContext";
const App = () => {
  const element = useRoutes(routes);

// useEffect(() => {
//   const hasLoadedBefore = sessionStorage.getItem("app_loaded");

//   if (!hasLoadedBefore) {
//     // first time in this tab
//     localStorage.removeItem("token");
//     sessionStorage.setItem("app_loaded", "true");
//   }
// }, []);
  return (
    <UserProvider>
      {/* <ScrollToTop /> */}
      {/* <ServiceProvider> */}
        {element}
      {/* </ServiceProvider> */}
    </UserProvider>
  );
};

export default App;
